import { UserCard } from "@components/user-card";

/**
 * IMPORTS
 */
const users = [
  {
    name: "Tony Stark",
    email: "tonystark@jarvis.com",
    phone: "+971 12345 09876",
    productPermission: "View",
    orderPermission: "Manage",
    inventoryPermission: "Manage",
    imageUrl: "https://i.imgur.com/0y8Ftya.png", // Exemplo 1
  },
  {
    name: "Tony Stark",
    email: "tonystark@jarvis.com",
    phone: "+971 12345 09876",
    productPermission: "View",
    orderPermission: "Manage",
    inventoryPermission: "Manage",
    imageUrl: "https://i.imgur.com/AfFp7pu.png", // Exemplo 2
  },
];

const UsuariosCliente = () => {
  return (
    <div className="mx-auto w-full space-y-4">
      <div className="mb-4 flex items-center justify-between">kk</div>

      {users.map((user, index) => (
        <UserCard key={String(index)} user={user} />
      ))}
    </div>
  );
};

/**
 * EXPORTS
 *
 */
export { UsuariosCliente };
